// locales/en-US/termsOfService.ts

const termsOfServiceStrings = {
    seoTitle: "La Estrellita | Terms of Service",
    pageTitle: "Terms of Service",
    headerTitle: "Terms Of Service",

    introParagraph:
        "Welcome to La Estrellita! These Terms of Service (\"Terms\") govern your use of our website. By accessing or using our website, you agree to comply with and be bound by these Terms. If you do not agree, please refrain from using our website.",

    section1Title: "1. Website Usage",
    section1Text:
        "Our website is intended to provide general information about La Estrellita, including our menu, business hours, location, and contact details. All content is for informational purposes only and may be updated without notice.",

    section2Title: "2. User Conduct",
    section2Text:
        "When using our website, you agree to:",
    section2List: [
        "Use the site only for lawful purposes.",
        "Not attempt to gain unauthorized access to any part of the site.",
        "Respect all intellectual property rights related to the content provided.",
    ],

    section3Title: "3. Intellectual Property",
    section3Text:
        "All content on this website—including text, images, logos, and layout—is the property of La Estrellita and is protected by copyright and trademark laws. You may not reproduce or distribute any part of the website without our prior written consent.",

    section4Title: "4. Third-Party Links",
    section4Text:
        "Our website may contain links to third-party websites for your convenience (e.g., delivery services or review platforms). La Estrellita is not responsible for the content or practices of those websites.",

    section5Title: "5. Disclaimer",
    section5Text:
        "The information on this website is provided \"as is\" and without warranties of any kind. While we strive for accuracy, La Estrellita does not guarantee the completeness, reliability, or timeliness of the information provided.",

    section6Title: "6. Limitation of Liability",
    section6Text:
        "To the extent permitted by law, La Estrellita shall not be liable for any damages arising out of or related to your use of our website, including but not limited to direct, indirect, incidental, or consequential damages.",

    section7Title: "7. Modifications",
    section7Text:
        "La Estrellita reserves the right to update or modify these Terms at any time without prior notice. Your continued use of the website after changes have been posted indicates your acceptance of the updated Terms.",

    section8Title: "8. Contact Us",
    section8Text: "If you have any questions or concerns regarding these Terms, please contact us at",
    contactEmail: " laestrellitasc@gmail.com",

    consentText:
        "By using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.",
};

export default termsOfServiceStrings;
